<template>
	<span class="bottomBadge">
		<a v-if="href" :href="href" target="_top"><sym-icon v-if="icon" :name="icon" :style="iconColor"></sym-icon><span v-if="value">&nbsp;{{ value }}</span></a>
		<span v-else><sym-icon v-if="icon" :name="icon" :style="iconColor"></sym-icon><span v-if="value">&nbsp;{{ value }}</span></span>
	</span>
</template>

<script setup lang="ts">
import SymIcon from "@fd/helpers/SymIcon.vue";
import {computed, type CSSProperties} from "vue";

const props = defineProps<{
	icon?: string,
	value?: string | number,
	color?: string,
	href?: string
}>();

const iconColor = computed<CSSProperties>(() => {
	const s: CSSProperties = {};
	if (props.color) {
		s.color = props.color;
	}
	return s;
});
</script>

<style>

</style>